const QasimAwan = () => {
  return (
    <div>
      <div className="bg-[#fcfcfc] pt-[2rem]">
        <div className="sm:max-w-[70rem] mx-auto sm:px-[10rem] lg:flex lg:justify-between grid items-end">
          <div className="mb-[2.5rem] lg:grid hidden">
            <h1 className="sm:text-[30px] text-[30px] font-bold">Qasim Awan</h1>
            <p>Executive Director</p>
          </div>
          <div className="flex justify-end mx-[2rem]">
            <img
              src="/leadershipnew/qasim-awan.jpg"
              alt=""
              className="lg:h-[26rem] h-[17rem] leadership-images"
            />
          </div>
          <div className="mb-[2.5rem] mx-[2rem]  lg:hidden grid justify-left mt-[.7rem]">
            <h1 className="sm:text-[30px] text-[26px] font-bold">Qasim Awan</h1>
            <p>Executive Director</p>
          </div>
        </div>
      </div>
      <div className="sm:max-w-[50rem] lg:mx-auto md:mx-[5rem] mx-[2rem] my-[4rem] flex flex-col justify-center items-center text-justify gap-4">
        <p>
          Qasim Awan joined TCS in 2012, after graduating from York University,
          Canada. He has a Master’s in Management from the Cass Business School,
          University of London. Prior to joining TCS he worked for a few years
          with an Accounting and Management firm in Dubai, UAE. He has attended
          several programmes in Personal Development, E-commerce and
          International Business.
        </p>
        <p>
          During the past ten years at TCS, Qasim has passionately pursued his
          interest in the e-commerce industry, particularly e-com logistics and
          supply chain warehousing. He has traveled across TCS network in
          Pakistan in the company’s own trucks and aircraft, but the most
          enjoyable learning for him has been on courier bikes in the
          neighbourhoods he would have never visited otherwise. He appreciates
          the profound impact which the TCS values, his ongoing learning
          experiences, and the camaraderie he developed with the TCS ranks and
          files, have left on him. Qasim has attended the Director Course at the
          Pakistan Institute of Corporate Governance, prior to becoming the
          member of the Board of TCS Holdings.
        </p>
        <p>
          Qasim is the recipient of a Presidents Award for instilling team
          spirit within the company. He is an avid observer of the technological
          and regional developments reshaping the industry. He is also a member
          of the Digital Economy Commission of ICC Pakistan and Karachi Council
          of Foreign Relations. He has been contributing to various publications
          on this subject. Qasim is also a sportsman and sport commentator.
        </p>
        {/* <p>
                He is also an avid observer of the technological and regional developments reshaping the industry, 
                contributing to various publications on this subject.
            </p>
            <p>
                He has traveled extensively across TCS facilities in Pakistan in the company’s own trucks and aircraft, 
                but the most enjoyable learning for him has been on courier bikes in communities he would have otherwise 
                never visited.
            </p>
            <p>
                He deeply values the learning experience and camaraderie thus developed with the TCS rank and file.
            </p>
            <p>
                He is the recipient of a Presidents Award for instilling team spirit within the company.
            </p>
            <p>
                Qasim has attended the Director Course at the Pakistan Institute of Corporate Governance, 
                prior to his induction on the Board of TCS Holdings.
            </p>
            <p>
                Qasim is also a sportsman and sport commentator.
             </p>
            <p>
                He is a member of the Digital Economy Commission of ICC Pakistan and Karachi Council of Foreign Relations.
            </p> */}
      </div>
    </div>
  );
};
export default QasimAwan;
